import React, { useState, useEffect } from 'react';
import { Text, Button, Switch } from '@radix-ui/themes';

interface CsCompletePreparationProps {
  onDone: () => void;
  setFileUrl: (url: string) => void;
  activePresentation: (type: string) => void;
}

const CsCompletePreparation: React.FC<CsCompletePreparationProps> = ({ onDone, setFileUrl, activePresentation }) => {
  const [prepOption, setPrepOption] = useState('');
  const [file, setFile] = useState<string | null>(null);
  const [error, setError] = useState('');

  useEffect(() => {
    setError('');
  }, [prepOption, file]);

  const handleDone = () => {
    if (prepOption === 'case_url' && !file) {
      setError('Please select document to upload!');
      return;
    }
    onDone();
  };

  const uploadDocument = async (event: React.ChangeEvent<HTMLInputElement>) => {
    const selectedFile = event.target.files?.[0];
    // if (selectedFile && ['application/pdf', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'].includes(selectedFile.type)) {
    //   try {
    //     // Simulate file upload to S3 (replace with your actual S3 upload logic)
    //     const _url = await uploadFileonS3(selectedFile); // Implement this function
    //     setFileUrl(_url?.body?.postResponse?.location || '');
    //     setFile(_url?.body?.postResponse?.location || '');
    //   } catch (error) {
    //     console.log('Unable to upload document due to:', error);
    //   }
    // } else {
    //   setError('Please select a valid PDF or Word document.');
    // }
  };

  // Placeholder for S3 upload function (implement based on your backend)
  const uploadFileonS3 = async (file: File): Promise<any> => {
    // Replace with actual S3 upload logic (e.g., using AWS SDK)
    console.log('Uploading file:', file.name);
    return new Promise((resolve) => {
      setTimeout(() => resolve({ body: { postResponse: { location: `/uploads/${file.name}` } } }), 1000); // Mock response
    });
  };

  return (
    <div className="flex flex-1 flex-col items-center justify-center">
      <Text className="text-white font-[Lato-Regular] text-base w-[40vw] mt-4 text-center">
        Complete preparation for your presentation
      </Text>

      <div className="flex flex-row items-center my-2">
        <Text className="text-white font-[Lato-Regular] text-sm w-[40vw]">
          Share Screen
        </Text>
        <Switch
          checked={prepOption === 'share_screen'}
          onCheckedChange={(checked) => {
            if (!checked) {
              setPrepOption('');
              activePresentation('');
            } else {
              setPrepOption('share_screen');
              activePresentation('share_screen');
            }
          }}
          className="data-[state=checked]:bg-blue-600 data-[state=unchecked]:bg-gray-600"
        />
      </div>

      <div className="flex flex-row items-center my-2">
        <Text className="text-white font-[Lato-Regular] text-sm w-[40vw]">
          Share Whiteboard
        </Text>
        <Switch
          checked={prepOption === 'share_whiteboard'}
          onCheckedChange={(checked) => {
            if (!checked) {
              setPrepOption('');
              activePresentation('');
            } else {
              setPrepOption('share_whiteboard');
              activePresentation('share_whiteboard');
            }
          }}
          className="data-[state=checked]:bg-blue-600 data-[state=unchecked]:bg-gray-600"
        />
      </div>

      <div>
        <div className="flex flex-row items-center my-2">
          <Text className="text-white font-[Lato-Regular] text-sm w-[40vw]">
            Attach Document/ media to present
          </Text>
          <Switch
            checked={prepOption === 'case_url'}
            onCheckedChange={(checked) => {
              if (!checked) {
                setPrepOption('');
                activePresentation('');
              } else {
                setPrepOption('case_url');
                activePresentation('case_url');
              }
            }}
            className="data-[state=checked]:bg-blue-600 data-[state=unchecked]:bg-gray-600"
          />
        </div>

        {prepOption === 'case_url' && (
          <label className="cursor-pointer px-4 py-2 rounded-lg border border-white text-white font-[Lato-Regular] text-sm">
            Upload Document
            <input
              type="file"
              accept=".pdf,.doc,.docx"
              className="hidden"
              onChange={uploadDocument}
            />
          </label>
        )}
      </div>

      {error && (
        <Text className="text-red-500 font-[Lato-Regular] text-sm my-2">
          {error}
        </Text>
      )}

      <Button
        onClick={handleDone}
        className="bg-blue-600 hover:bg-blue-700 text-white font-[Lato-Regular] text-sm rounded-lg py-2 px-7 shadow-md mb-4"
      >
        Done
      </Button>
    </div>
  );
};

export default CsCompletePreparation;